import React, { PureComponent } from "react";
import './Menu.css';
import Button from '../Button/Button.js';
import Constants from '../Constants.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlock } from '@fortawesome/free-solid-svg-icons'
library.add(faUnlock);

class Paywall extends PureComponent {
    render() {

        const price = this.props.prices.levels;

        return (
            <div
                style={{
                    width: '100%',
                    position: 'relative',
                    marginBottom: '40px',
                    marginTop: '40px',
                    borderRadius: '20px',
                }}
            >
                <div
                    style={{
                        width: '80%',
                        position: 'relative',
                        left: '10%',
                        backgroundColor: '#fff',
                    }}
                >
                    <p className="Paragraph">
                        Can't get enough {Constants.name}? Unlock all previous levels and purchase {Constants.paidLevels} more!
                    </p>
                    <div
                        style={{
                            display: 'inline-block',
                            boxSizing: 'border-box',
                        }}
                    >
                        <Button
                            activeColor={'#fff'}
                            inactiveColor={'#3c40c6'}
                            borderColor={'#3c40c6'}
                            onClick={() => {
                                if (window.store) {
                                    window.store.order('levels');
                                }
                            }}
                        >
                            <FontAwesomeIcon className="ButtonIcon" icon="unlock" />
                            Unlock Now
                        </Button>
                        <div
                            className="Price"
                        >
                            {price && 'for ' + price}
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        height: '1px',
                        backgroundColor: 'lightgray',
                        zIndex: '-1',
                    }}
                >
                </div>

            </div>
        );
    }
}

export default Paywall;
